import { TipoTopicoNotificacaoEnum, TopicoNotificacao } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import {
  InscricoesTopicosNotificacaoContextModel,
  NotificacaoCountContextModel,
  NotificacaoPubSubResponseList,
} from './model-notificacaoContext'

export function createDefaultCountTipoNotificacaoRecord(): NotificacaoCountContextModel {
  return {
    [TipoTopicoNotificacaoEnum.CUIDADO_COMPARTILHADO]: 0,
    [TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL]: 0,
  }
}

export function createDefaultInscricoesTopicosNotificacaoRecord(): InscricoesTopicosNotificacaoContextModel {
  return {
    [TipoTopicoNotificacaoEnum.CUIDADO_COMPARTILHADO]: {},
    [TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL]: {},
  }
}

export function mapQueryToInscricoes(
  topicos: ReadonlyArray<Partial<TopicoNotificacao>>
): InscricoesTopicosNotificacaoContextModel {
  let acc = createDefaultInscricoesTopicosNotificacaoRecord()

  topicos.forEach((topico) => {
    const bucketAnterior = acc[topico.tipoTopico] || {}

    const bucketAtualizado: Record<ID, any> = {
      ...bucketAnterior,
      [topico.codigoTopicoExterno]: {
        id: topico.id,
        tipoTopico: topico.tipoTopico,
        codigoTopicoExterno: topico.codigoTopicoExterno,
        statusNotificarLido: topico.statusNotificarLido,
        statusNotificarVisto: topico.statusNotificarVisto,
        updatedAt: topico.dataUltimaAtualizacao,
      },
    }

    acc = {
      ...acc,
      [topico.tipoTopico]: bucketAtualizado,
    }
  })

  return acc
}

export function recomputeCounts(
  inscricoesTopicos: InscricoesTopicosNotificacaoContextModel
): NotificacaoCountContextModel {
  let acc = createDefaultCountTipoNotificacaoRecord()

  Object.entries(inscricoesTopicos).forEach(([tipo, bucket = {}]) => {
    let count = 0
    Object.values(bucket).forEach((item) => {
      if (item?.statusNotificarVisto) count++
    })
    acc = { ...acc, [tipo]: count }
  })

  return acc
}

export function applyAtmosphereMessages(
  current: InscricoesTopicosNotificacaoContextModel,
  mensagens: NotificacaoPubSubResponseList
): InscricoesTopicosNotificacaoContextModel {
  let next = current

  mensagens.forEach((mensagem) => {
    const tipo = mensagem.tipoNotificacao
    const id = mensagem.idRegistroExterno
    const bucketAtual = next[tipo] || {}
    const atual = bucketAtual[id]

    const prevUpdated = atual?.updatedAt ?? 0
    const timestamp = mensagem.timestamp ?? 0
    if (atual && prevUpdated >= timestamp) return

    switch (mensagem.operacao) {
      case 'SUBSCRIBE': {
        const novoItem = {
          id: mensagem.idTopico,
          tipoTopico: mensagem.tipoNotificacao,
          codigoTopicoExterno: mensagem.idRegistroExterno,
          statusNotificarLido: mensagem.notificarLido,
          statusNotificarVisto: mensagem.notificarVisto,
          updatedAt: mensagem.timestamp,
        }
        next = { ...next, [tipo]: { ...bucketAtual, [id]: novoItem } }
        return
      }

      case 'UNSUBSCRIBE': {
        if (!atual) return
        const bucketSem: Record<ID, typeof atual> = { ...bucketAtual }
        delete bucketSem[id]
        next = { ...next, [tipo]: bucketSem }
        return
      }

      case 'UPDATE': {
        if (!atual) return
        const novoItem = {
          ...atual,
          statusNotificarLido: isUndefinedOrNull(mensagem.notificarLido)
            ? atual.statusNotificarLido
            : mensagem.notificarLido,
          statusNotificarVisto: isUndefinedOrNull(mensagem.notificarVisto)
            ? atual.statusNotificarVisto
            : mensagem.notificarVisto,
          updatedAt: mensagem.timestamp,
        }
        next = { ...next, [tipo]: { ...bucketAtual, [id]: novoItem } }
        return
      }
    }
  })

  return next
}
